<script setup lang="ts">
import type { IProductEntityBadge } from '~/entities';
import { MMText } from '@mm-frontend/mm-web-ui-kit';
import { MMBadge } from '~/features/ui-kit';

defineProps<{
  title: string;
  badges?: IProductEntityBadge[];
}>();
</script>

<template>
  <div class="sku-popup-header">
    <MMText font="Title L/Medium" font-mobile-or-tablet="Body M/Medium">{{ title }}</MMText>

    <div v-if="badges" class="sku-popup-header__badges">
      <MMBadge
        v-for="badge in badges"
        :key="badge.id"
        :label="badge.text"
        :text-color="badge.textColor"
        :background-color="badge.backgroundColor"
      />
    </div>
  </div>
</template>

<style scoped lang="stylus">
.sku-popup-header
  display flex
  flex-direction column
  gap 8px
  padding-right 32px

  &__badges
    display flex
    flex-wrap wrap
    gap 8px
</style>
